import { Box, Typography } from "@mui/material";
import { useScrollReveal } from "../helpers/ScrollReveal";

export const HeroSectionComponent = ({ image, text }) => {
  useScrollReveal([
    {
      selector: ".revealFromTopSectionOne",
      options: {
        duration: 1000,
        easing: "ease-out",
        origin: "top",
        reset: false,
      },
    },
  ]);
  return (
    <Box
      component="section"
      sx={{
        backgroundColor: "#ffffff",
        width: "100%",
        height: "100vh",
        minHeight: "600px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
      className="revealFromTopSectionOne"
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)), url(${image})`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      />
      {text && (
        <Typography
          sx={{
            position: "absolute",
            fontSize: { xs: "40px", md: "70px" },
            maxWidth: "80%",
            textAlign: "center",
            fontWeight: "bold",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            textShadow: "0 1px 1px #000, 0 1px 2px #000, 0 2px 6px #000",
            letterSpacing: "0.2em",
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};
